import { FileCheck } from "lucide-react";
import { TERMS_SECTIONS, TERMS_VERSION, TERMS_EFFECTIVE } from "../data/terms";

export default function Terms() {
  return (
    <main data-testid="terms-page" className="pt-20 md:pt-24 min-h-screen">
      <section className="py-20 sm:py-24 border-b border-zinc-800/60">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm w-12 h-12 flex items-center justify-center mb-6">
            <FileCheck className="h-6 w-6 text-blue-500" />
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-none text-white mb-4">
            Terms of Service &<br />Repair Authorization
          </h1>
          <p className="text-zinc-500 text-sm">Version {TERMS_VERSION} · Effective {TERMS_EFFECTIVE}</p>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-12 space-y-10">
          {TERMS_SECTIONS.map((s) => (
            <div key={s.title}>
              <h2 className="font-heading text-lg font-semibold text-white mb-2">{s.title}</h2>
              <p className="text-zinc-400 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
